import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InspectionService } from 'src/app/services/inspection.service';
import { FormBuilder, FormControl } from '@angular/forms';
import { MessageBannerServiceService } from '../services/message-banner-service.service';

interface InspectionIdUploadCertification {
  inspectionId: string,
  uploadType?: 'manualInspection' | 'normalInspection',
}

@Component({
  selector: 'app-upload-certification',
  templateUrl: './upload-certification.component.html',
  styleUrls: ['./upload-certification.component.scss']
})
export class UploadCertificationComponent implements OnInit {

  placeholdertemplate = '';
  miCampo: FormControl = this.fb.control('');
  file: File | null = null;
  selectedFile: any = null;


  constructor(
    public dialogo: MatDialogRef<UploadCertificationComponent>,
    private popUpService: MessageBannerServiceService,
    @Inject(MAT_DIALOG_DATA) public data: InspectionIdUploadCertification,
    private inspectionService: InspectionService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.miCampo.setValue("SELECT A FILE TO UPLOAD");
  }

  upload() {
    if (this.selectedFile === null) {
      this.popUpService.showMessage('ALERT', 'First select a File', false, true, false);
    }
    else {
      if (this.data.uploadType == 'manualInspection') {
        this.inspectionService.uploadFileEvidence(this.data.inspectionId, this.selectedFile)
          .subscribe(
            {
              next: (valor) => {
                console.log("⭕️--> ~ upload-certification.component.ts:73 ~ UploadCertificationComponent ~ uploadEvidence ~ valor:", valor)
                location.reload();
              }, error: (error: HttpErrorResponse) => {
                console.log("⭕️--> ~ upload-certification.component.ts:61 ~ UploadCertificationComponent ~ upload ~ error:", error)
                this.popUpService.showMessage('ERROR', 'Error while sending the file: ' + error.error, false, true, false);
              }
            });
      } else {
        const formData = new FormData();
        // formData.append('InspectionID', this.data.inspectionId);
        formData.append('File', this.selectedFile, this.selectedFile.name);

        this.inspectionService.uploadCerficationDocumentation(formData, this.data.inspectionId)
          .subscribe((valor) => {
            if (valor.id != 0) {
              this.popUpService.showMessage('ALERT', 'File was imported correctly', false, true, false, (resp) => {
                location.reload();  // Reemplaza esto con cualquier lógica que necesites
                console.log('Diálogo cerrado:', resp);
              });
            }
          },
            (error: HttpErrorResponse) => {
              const errors = error.error.error || error.error;
              this.popUpService.showMessage('ERROR', 'Error while sending the file: ' + errors, false, true, false);
            });
      }
    }
  }

  onFileSelected(event: any) {
    const input = event.target as HTMLInputElement;
    const selectedFile = input.files?.item(0);

    if (!selectedFile) {
      return;
    }

    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

    if (selectedFile.size > MAX_FILE_SIZE) {
      this.popUpService.showMessage(
        'ALERT',
        'The selected file cannot exceed 5 MB',
        false,
        true,
        false
      );
      input.value = '';
      this.selectedFile = null;
      this.file = null;
      this.miCampo.setValue('SELECT A FILE TO UPLOAD');

      return;
    }

    this.selectedFile = selectedFile;
    this.file = selectedFile;
    this.miCampo.setValue(selectedFile.name);
  }

  cerrarDialogo(): void {
    this.miCampo.setValue('');
    this.dialogo.close(false);
    this.file = null;
  }
}
